export const API = {
  ADDUSER: "/user/addUser",
  FETCHUSERS: "/mongo/modules/login",
  fetchUserInfo: "/mongo/modules/roles",
  LOGINUSER: "/mongo/modules/login",
  LOGOUTUSER: "/user/logoutUser",
  FETCHDEALDATA:'/mongo/modules/get',
  FETCHKDDTILEDATA:"/mongo/modules/sub_get",
  FILEVALIDATIONEXCELFILE:'/mongo/validation/kdd',
  UPLOADKDDFILE:"/bq/bq_kdd/add_kdd",
  GETKDDDATA:"/bq/bq_kdd/get_kdd",
  GETDEALSEARCHAPI:'/mongo/modules/search',
  GETDATEOPTIONSINKDD:'/bq/bq_kdd/get_kdd_date_options',
  GETTITLEOPTIONSINKDD:'/bq/bq_kdd/get_kdd_title_options',
  GETFILENAMEOPTIONSINKDD:"/bq/bq_kdd/get_kdd_files_options",
  GETSUBMODULESEARCH:"/mongo/modules/sub_search",
  PostPreviewExistingData:'/bq/bq_kdd/read_kdd_file',
  ExportKddFileData:'bq/bq_kdd/export_Kdd_data',
  FileValidationOfAsap:"/mongo/validation/asap",
  UploadAsapFile:"/asap/add_asap",
  GetAsapData:'/asap/get_asap',
  GetMarketingActivity:'/asap/get_asap_marketing_activity_options',
  GetTitleOfAsap:"/asap/get_asap_title_options",
  GetFilenameOfAsap:"/asap/get_asap_files_options",
  downloadASAPexportFile:"/asap/export_asap_data",
  PreviewExistingAsapData:"/asap/read_asap_file",
  PreviewExistingBookBUBData:"/deal/book_bub/read_bookbub_file",
  GetbookBubTemplate:'/deal/book_bub/download_book_bub_template',
  GetBookBubInfo:"/deal/book_bub/download_book_bub_info",
  UploadFileBookBub:"/deal/book_bub/add_bookbub",
  FileValidationOfBookBub:"/mongo/validation/bookbub",
  GetBookBubDataInTable:"/deal/book_bub/get_bookbub",
  GetBookbubISbnOptions:'/deal/book_bub/get_bookbub_isbn_options',
  GetBookBubDealOptions:"/deal/book_bub/get_Deal_date_options",
  GetBookBubTitleOptions:"/deal/book_bub/get_bookbub_title_options",
  downloadBookBubExcelData:"/deal/book_bub/export_bookbub_data"
};
